import { Directive, forwardRef, Inject } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../core/user.service';

@Directive({
  selector: '[appExistsUserName][ngModel],[appExistsUserName][formControl]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, multi: true,
    useExisting: forwardRef(() => ExistsUserNameValidator),
  }],
})
export class ExistsUserNameValidator implements AsyncValidator {

  constructor(
    private userService: UserService
  ) {
  }
  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return this.userService.checkNameNotTaken(control.value).map(exists => {
        return exists ? {'nameExists': true} : null;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-services/exists-user-name.validator.ts